import React, { useState } from 'react';
import { supabase } from '../../lib/supabaseClient';
import '../auth/Signup.css';

const Login = ({ onNavigate }) => {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  // ─── EMAIL LOGIN ─────────────────────────────────────────────────────────
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Please enter your email and password'); return; }
    setLoading(true);
    setError('');

    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });

    if (authError) {
      setError('Invalid email or password. Please try again.');
      setLoading(false);
      return;
    }

    onNavigate('dashboard');
  };

  // ─── LINKEDIN LOGIN ───────────────────────────────────────────────────────
  const handleLinkedIn = async () => {
    setLoading(true);
    setError('');

    const { error: authError } = await supabase.auth.signInWithOAuth({
      provider: 'linkedin_oidc',
      options: {
        redirectTo: `${window.location.origin}/dashboard`,
      },
    });

    if (authError) {
      setError('LinkedIn sign in failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="signup-page">
      <nav className="signup-nav">
        <div className="signup-nav-logo" onClick={() => onNavigate('home')}>
          Umpire<span>IQ</span>
        </div>
        <span className="signup-nav-login">
          Don't have an account?
          <a href="#" onClick={e => { e.preventDefault(); onNavigate('signup'); }}> Sign up</a>
        </span>
      </nav>

      <div className="signup-body">
        <div className="signup-card">

          <div className="signup-step-eyebrow">Welcome back</div>
          <h2>Sign in</h2>
          <p className="signup-card-sub">Sign in to access your UmpireIQ profile and dashboard.</p>

          {error && <div className="signup-error">{error}</div>}

          {/* LinkedIn button */}
          {/* LinkedIn OAuth — coming soon, hidden until post-launch
          <button
            onClick={handleLinkedIn}
            disabled={loading}
            style={{
              width: '100%',
              padding: '13px',
              background: '#0A66C2',
              color: '#fff',
              border: 'none',
              borderRadius: 'var(--radius-sm)',
              fontFamily: 'var(--sans)',
              fontSize: '14px',
              fontWeight: 500,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: '20px',
              opacity: loading ? 0.6 : 1,
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
            Continue with LinkedIn
          </button>   */}

          
          {/* Divider */}
          {/*
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
            <span style={{ fontSize: '12px', color: 'var(--muted)', whiteSpace: 'nowrap' }}>or sign in with email</span>
            <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
          </div>
          */}

          {/* Email form */}
          <form onSubmit={handleLogin}>
            <div className="signup-field">
              <label className="signup-label">Email</label>
              <input
                className="signup-input"
                type="email"
                placeholder="your@firm.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>

            <div className="signup-field">
              <label className="signup-label">Password</label>
              <input
                className="signup-input"
                type="password"
                placeholder="Your password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            <div style={{ textAlign: 'right', marginBottom: '20px', marginTop: '-8px' }}>
              <button
                type="button"
                onClick={() => onNavigate('forgot')}
                style={{ background: 'none', border: 'none', color: 'var(--gold)', fontSize: '13px', cursor: 'pointer', padding: 0 }}
              >
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              className="signup-btn-primary"
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

        </div>
      </div>
    </div>
  );
};

export default Login;
